import React from 'react'
import TextFieldUniversal from '../../validate/form/text/TextFieldUniversal'
import { useState } from 'react'

const SkuFieldMain = ({ required, setValidate, setValueForm, forciblyValue, className }) => {

    const [value, setValue] = useState('')

  return (
    <div className={className}>
		<TextFieldUniversal
			value={value}
			setValue={e => {
				setValueForm(e)
				setValue(e)
			}}
			setValidate={setValidate}
			label={'Артикул'} 
			placeholder={'102991'}
			validates={{
				isEmpty: true,
			}}
			forciblyValue={forciblyValue}
			required={required}
		/>
	</div>
  )
}

export default SkuFieldMain